<template>
    <el-container direction="vertical" class="card">
        <el-row class="card-header">
            <el-col :span="6">
                <div class="bold fnt-lg dark text-left">
                    <div class="description">
                        <el-button type="warning" @click="$router.push({name: 'home'})" icon="el-icon-arrow-left">
                            на главную
                        </el-button>
                        403. Доступ запрещен
                    </div>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import '@/assets/styles/card.scss';

export default {
    name: 'Page403'
};
</script>
